import React, { useEffect, useRef } from 'react';
import './WhyChooseSection.css';
import { FaUserGraduate, FaChalkboardTeacher, FaUsers, FaHandHoldingHeart, 
         FaLaptopCode, FaTrophy, FaGraduationCap, FaSchool, FaChartLine, FaSeedling,
         FaStar, FaHeart, FaUserCog, FaShieldAlt, FaMedal } from 'react-icons/fa';

const WhyChooseSection = ({ children }) => {
  const sectionRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);

  const features = [
    {
      icon: <FaUserGraduate />,
      title: '1-on-1 Mentoring',
      description: 'Personalized guidance for every student ensuring individual attention and growth.'
    },
    {
      icon: <FaChalkboardTeacher />,
      title: 'Multiple Board Concept Learning',
      description: 'Interactive, engaging, and effective teaching across different educational boards.'
    },
    {
      icon: <FaUsers />,
      title: 'Cluster Mentoring Approach',
      description: 'Collaborative learning environment that promotes peer support and group dynamics.'
    },
    {
      icon: <FaHandHoldingHeart />,
      title: 'Counselor Buddy System',
      description: 'Dedicated support for academic and emotional well-being of students.'
    },
    {
      icon: <FaLaptopCode />,
      title: 'Hybrid Studio Classes',
      description: 'Future-ready learning environment blending physical and digital education.'
    },
    {
      icon: <FaTrophy />,
      title: 'Competitive Exam Preparation',
      description: 'Comprehensive coaching for success in various competitive examinations.'
    },
    {
      icon: <FaGraduationCap />,
      title: 'Expert Faculty',
      description: 'Learn from the best educators in the field with proven expertise.'
    },
    {
      icon: <FaSchool />,
      title: 'Modern Classrooms',
      description: 'State-of-the-art facilities equipped with cutting-edge technology.'
    },
    {
      icon: <FaChartLine />,
      title: 'Competitive Edge Programs',
      description: 'Advanced training programs designed for high-achieving students.'
    },
    {
      icon: <FaSeedling />,
      title: 'Holistic Learning Environment',
      description: 'Focus on overall development beyond academics for personal growth.'
    },
    {
      icon: <FaStar />,
      title: 'Subject Matter Experts',
      description: 'Highly qualified professionals with expertise in Mathematics, Science, GK, and SSB training.'
    },
    {
      icon: <FaHeart />,
      title: 'Passionate Educators',
      description: 'Making complex concepts simple with dedication and excellence in teaching.'
    },
    {
      icon: <FaUserCog />,
      title: 'Personalized Mentoring',
      description: 'Individual attention and guidance to help students reach their full potential.'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Defence Exam Specialists',
      description: 'First-hand experience with defence exams and SSB selection process.'
    },
    {
      icon: <FaMedal />,
      title: 'Excellence Beyond Classroom',
      description: 'Building discipline, leadership, resilience, and problem-solving skills.'
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in-visible');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px'
      }
    );

    const section = sectionRef.current;
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  // Split features into two rows (7-8 cards each)
  const row1Features = features.slice(0, 8);
  const row2Features = features.slice(8);

  return (
    <section className="why-choose-section fade-in" ref={sectionRef}>
      {children}
      <div className="container">
        <h2 className="section-title">Welcome to ADCI</h2>
        <div className="features-container">
          <div className="features-row" ref={row1Ref}>
            {[...row1Features, ...row1Features].map((feature, index) => (
              <div className="feature-card" key={index}>
                <div className="icon-wrapper">
                  {feature.icon}
                </div>
                <div className="feature-content">
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="features-row reverse" ref={row2Ref}>
            {[...row2Features, ...row2Features].map((feature, index) => (
              <div className="feature-card" key={index}>
                <div className="icon-wrapper">
                  {feature.icon}
                </div>
                <div className="feature-content">
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
